/**
 * @generated SignedSource<<31d00296685a836ff15cbbc7a13f75b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSearchCorrections_itemSearch$data = {
  readonly searchCorrections: {
    readonly semanticSearchTerm: string | null;
    readonly classificationLevel: string | null;
    readonly classificationSearchTerm: string | null;
  } | null;
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
      readonly urlLabel: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "useSearchCorrections_itemSearch";
};
export type useSearchCorrections_itemSearch$key = {
  readonly " $data"?: useSearchCorrections_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSearchCorrections_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useSearchCorrections_itemSearch"
};

(node as any).hash = "756775493e381f3a421185b943c71949";

export default node;
